export const supplementaryCoverSelectionModeTypeEnum = Object.freeze({
  MULTIPLE_FACULTATIF: 'MULTIPLE_FACULTATIF',
  MULTIPLE_OBLIGATOIRE: 'MULTIPLE_OBLIGATOIRE',
  UNIQUE_FACULTATIF: 'UNIQUE_FACULTATIF',
  UNIQUE_OBLIGATOIRE: 'UNIQUE_OBLIGATOIRE'
});
